/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: utils.ts
 🗓️ Created: 2025-01-05
 🧩 Description:
    Utility functions and helper methods for common operations
    throughout the Ring2All Platform application.

 🔧 Notes:
    - Implements className merging utility for Tailwind CSS
    - Provides date formatting and manipulation functions
    - Includes common utility functions for data processing
    - Supports consistent styling and formatting across components
    - Integrates with clsx and tailwind-merge for optimal performance
    - Provides reusable helper functions for the entire application

 🔁 Last Updated: 2025-01-05 by Rodrigo Cuadra
────────────────────────────────────────────────────────────────*/

import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatDate(dateString: string) {
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  }).format(date);
}
